(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3459],{

/***/ 78883:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/login",
      function () {
        return __webpack_require__(17861);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 17861:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$$default": function() { return /* binding */ login_bs_$$default; },
  "Masquerade": function() { return /* binding */ login_bs_Masquerade; },
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ login_bs_$$default; },
  "wrapper": function() { return /* binding */ wrapper; }
});

// EXTERNAL MODULE: ./src/components/library/SeoMeta.bs.js
var SeoMeta_bs = __webpack_require__(81036);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/components/pages/login/LoginComponent.bs.js
var LoginComponent_bs = __webpack_require__(71764);
// EXTERNAL MODULE: ./src/layouts/OnboardingLayout.bs.js
var OnboardingLayout_bs = __webpack_require__(8103);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/pages/login/LoginOnboardingStyles.bs.js
var LoginOnboardingStyles_bs = __webpack_require__(70983);
// EXTERNAL MODULE: ./src/components/library/OnboardingLayoutCreateAccountButton.bs.js
var OnboardingLayoutCreateAccountButton_bs = __webpack_require__(38099);
;// CONCATENATED MODULE: ./src/components/pages/login/LoginOnboarding.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE





function LoginOnboarding(props) {
    return jsx_runtime.jsxs(OnboardingLayout_bs/* make */.S, {
        children: [
            jsx_runtime.jsx(OnboardingLayoutCreateAccountButton_bs/* make */.S, {}),
            jsx_runtime.jsx("div", {
                children: jsx_runtime.jsx(LoginComponent_bs.make, {}),
                className: LoginOnboardingStyles_bs/* loginContainer */._W
            })
        ],
        onboardingKind: /* ShowAppDownload */ 1
    });
}
var Link;
var make = LoginOnboarding;
var $$default = (/* unused pure expression or super */ null && (LoginOnboarding));
 /* LoginComponent Not a pure module */ 

;// CONCATENATED MODULE: ./src/components/pages/login/login-lazy.js


var login = dynamic_default()(function() {
    return Promise.resolve(make);
}, {
    ssr: false
});
var login_lazy_$$default = login;


;// CONCATENATED MODULE: ./src/components/pages/login/LoginLazy.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

var LoginLazy_bs_make = login_lazy_$$default;
 /* make Not a pure module */ 

// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/belt_Option.js
var belt_Option = __webpack_require__(72491);
// EXTERNAL MODULE: ./src/utils/PageContentResolver.bs.js
var PageContentResolver_bs = __webpack_require__(73763);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/api/queries/index.ts + 34 modules
var queries = __webpack_require__(22638);
// EXTERNAL MODULE: ./src/auth/user/AuthUtils.bs.js + 1 modules
var AuthUtils_bs = __webpack_require__(45603);
// EXTERNAL MODULE: ./src/utils/logger.ts
var logger = __webpack_require__(31611);
;// CONCATENATED MODULE: ./src/components/Masquerade.tsx





var Masquerade = function() {
    var ref, ref1;
    var router = (0,next_router.useRouter)();
    var masqUser = (ref = router.query) === null || ref === void 0 ? void 0 : ref.masq_user;
    var masqEndpoint = (ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.masq_endpoint;
    (0,react.useEffect)(function() {
        if (masqUser && masqEndpoint) {
            (0,queries/* masquerade */.XS)(masqEndpoint, masqUser).then(function(data) {
                (0,queries/* getCustomerData */.ck)({
                    Authorization: "Masq ".concat(data.token)
                }).then(function(customer) {
                    (0,AuthUtils_bs/* saveTokenCookie */.iB)({
                        userDetails: {
                            uid: (customer === null || customer === void 0 ? void 0 : customer.uid) || null,
                            firstName: customer === null || customer === void 0 ? void 0 : customer.firstName,
                            lastName: customer === null || customer === void 0 ? void 0 : customer.lastName,
                            phoneNumber: customer === null || customer === void 0 ? void 0 : customer.phone,
                            email: customer === null || customer === void 0 ? void 0 : customer.email
                        },
                        token: data.token,
                        masquerade: true
                    });
                    window.location.replace("/wallet/");
                });
            }).catch(function(err) {
                logger/* default.error */.ZP.error({
                    err: err,
                    source: "Masquerade API",
                    journey: "Masquerade"
                }, "error: failed to masquerade user ".concat(masqUser));
            });
        }
    }, []);
    return null;
};
/* harmony default export */ var components_Masquerade = (Masquerade);

;// CONCATENATED MODULE: ./src/pages/login.bs.js
__webpack_require__(14473);
// Generated by ReScript, PLEASE EDIT WITH CARE






var login_bs_make = components_Masquerade;
var login_bs_Masquerade = {
    make: login_bs_make
};
function Login$wrapper(props) {
    var loginContent = PageContentResolver_bs/* parse */.Qc(props.content);
    var f_seo_meta = function f_seo_meta(v) {
        return jsx_runtime.jsx(SeoMeta_bs/* make */.S, {
            meta: v.VAL
        });
    };
    var seo_meta = loginContent !== undefined ? belt_Option/* mapWithDefault */.k7(loginContent.seo_meta, null, f_seo_meta) : null;
    return jsx_runtime.jsxs(jsx_runtime.Fragment, {
        children: [
            seo_meta,
            jsx_runtime.jsx(login_bs_make, {}),
            jsx_runtime.jsx(LoginLazy_bs_make, {})
        ]
    });
}
var wrapper = Login$wrapper;
var login_bs_$$default = Login$wrapper;
var __N_SSP = true;
 /* make Not a pure module */ 


/***/ }),

/***/ 70026:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ useAuth; }
/* harmony export */ });
/* harmony import */ var _contexts_AuthContext_tsx__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35248);
// Generated by ReScript, PLEASE EDIT WITH CARE

function useAuth(prim) {
    return (0,_contexts_AuthContext_tsx__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)();
}
 /* ../../contexts/AuthContext.tsx Not a pure module */ 


/***/ }),

/***/ 47800:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p5": function() { return /* binding */ ssr_page_cache; },
/* harmony export */   "yN": function() { return /* binding */ no_cache; }
/* harmony export */ });
/* unused harmony export product_ssr_page_cache */
// Generated by ReScript, PLEASE EDIT WITH CARE
var ssr_page_cache = "public, max-age=600, stale-while-revalidate";
var product_ssr_page_cache = "public, max-age=60, stale-while-revalidate";
var no_cache = "private, no-cache, no-store, max-age=0, must-revalidate";
 /* No side effect */ 


/***/ }),

/***/ 75897:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony export Link */
/* harmony import */ var _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7667);
/* harmony import */ var _rescript_std_lib_es6_string_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99813);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(72491);
/* harmony import */ var _StaticImage_bs_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30369);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);
// Generated by ReScript, PLEASE EDIT WITH CARE






function DownloadAppleApp(props) {
    var baseHref = "https://itunes.apple.com/au/app/prezzee/id1047060902";
    var country = _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .EnvUtil.currentCountry */ .i3.currentCountry;
    var href;
    href = country.TAG === /* Ok */ 0 ? baseHref.replace("au", _rescript_std_lib_es6_string_js__WEBPACK_IMPORTED_MODULE_1__/* .lowercase_ascii */ .uq(_common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .EnvUtil.getCountryCode */ .i3.getCountryCode(country._0))) : baseHref;
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: href,
        prefetch: false,
        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx("a", {
            children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx(_StaticImage_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .make */ .S, {
                src: "/images/badge_apple_store.svg",
                alt: "Download on the App Store Logo",
                width: 125,
                height: 37,
                className: "w-full ml-1"
            }),
            className: _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_5__/* .getWithDefault */ .tj(props.className, "")
        })
    });
}
var Link$1;
var make = DownloadAppleApp;
 /* Util Not a pure module */ 


/***/ }),

/***/ 59195:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony export Link */
/* harmony import */ var _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7667);
/* harmony import */ var _rescript_std_lib_es6_string_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99813);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(72491);
/* harmony import */ var _StaticImage_bs_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30369);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);
// Generated by ReScript, PLEASE EDIT WITH CARE






function DownloadGoogleApp(props) {
    var baseHref = "https://play.google.com/store/apps/details?id=com.prezzee.prezzee";
    var country = _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .EnvUtil.currentCountry */ .i3.currentCountry;
    var href;
    href = country.TAG === /* Ok */ 0 ? baseHref + ("&gl=" + _rescript_std_lib_es6_string_js__WEBPACK_IMPORTED_MODULE_1__/* .lowercase_ascii */ .uq(_common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .EnvUtil.getCountryCode */ .i3.getCountryCode(country._0))) : baseHref;
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: href,
        prefetch: false,
        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx("a", {
            children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx(_StaticImage_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .make */ .S, {
                src: "/images/badge_play_store.svg",
                alt: "Download on the App Store Logo",
                width: 125,
                height: 37,
                className: "w-full mr-1"
            }),
            className: _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_5__/* .getWithDefault */ .tj(props.className, "")
        })
    });
}
var Link$1;
var make = DownloadGoogleApp;
 /* Util Not a pure module */ 


/***/ }),

/***/ 88767:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "make": function() { return /* binding */ make; }
/* harmony export */ });
/* harmony import */ var rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(20859);
/* harmony import */ var _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7667);
/* harmony import */ var _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72491);
/* harmony import */ var _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25400);
/* harmony import */ var react_markdown__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31758);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _NotificationStyles_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71434);
// Generated by ReScript, PLEASE EDIT WITH CARE







function $$Notification(props) {
    var notificationType = props.notificationType;
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx("div", {
        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs("div", {
            children: [
                react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx("div", {
                    children: _NotificationStyles_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .icon */ .qv(notificationType)
                }),
                react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs("div", {
                    children: [
                        _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_3__/* .mapWithDefault */ .k7(props.title, null, function(title) {
                            return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx("p", {
                                children: _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s(title),
                                className: _NotificationStyles_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .titleStyle */ .E3
                            });
                        }),
                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx("p", {
                            children: _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s(props.description),
                            className: _NotificationStyles_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .descriptionStyle */ .ab
                        }),
                        _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_3__/* .mapWithDefault */ .k7(props.markdown, null, function(m) {
                            return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx(react_markdown__WEBPACK_IMPORTED_MODULE_4__/* .ReactMarkdown */ .D, {
                                children: _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_5__/* .some */ .G(_common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s(m))
                            });
                        })
                    ]
                })
            ],
            className: _NotificationStyles_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .innerContainer */ .OM
        }),
        className: rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_6__/* .make */ .S([
            _NotificationStyles_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .rootContainer */ .$2(notificationType),
            _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_3__/* .getWithDefault */ .tj(props.className, "")
        ]),
        role: "alert"
    });
}
var make = $$Notification;
 /* Util Not a pure module */ 


/***/ }),

/***/ 71434:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$2": function() { return /* binding */ rootContainer; },
/* harmony export */   "E3": function() { return /* binding */ titleStyle; },
/* harmony export */   "OM": function() { return /* binding */ innerContainer; },
/* harmony export */   "ab": function() { return /* binding */ descriptionStyle; },
/* harmony export */   "qv": function() { return /* binding */ icon; }
/* harmony export */ });
/* unused harmony exports container, notificationStyle */
/* harmony import */ var rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20859);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
// Generated by ReScript, PLEASE EDIT WITH CARE


var container = "rounded-lg px-4 py-5 max-w-3xl text-left mx-auto";
var notificationStyle = "fill-current h-6 w-6 mr-4";
function rootContainer(notificationType) {
    switch(notificationType){
        case /* NotificationError */ 0:
            return rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .make */ .S([
                container,
                "bg-error-pink"
            ]);
        case /* NotificationInfo */ 1:
            return rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .make */ .S([
                container,
                "bg-info-blue"
            ]);
        case /* NotificationSuccess */ 2:
            return rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .make */ .S([
                container,
                "bg-success-green"
            ]);
        case /* NotificationWarning */ 3:
            return rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .make */ .S([
                container,
                "bg-warning-orange"
            ]);
    }
}
function icon(notificationType) {
    switch(notificationType){
        case /* NotificationError */ 0:
            return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs("svg", {
                children: [
                    react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx("mask", {
                        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx("path", {
                            d: "M15 0C6.75 0 0 6.75 0 15C0 23.25 6.75 30 15 30C23.25 30 30 23.25 30 15C30 6.75 23.25 0 15 0ZM22.3477 20.25L20.25 22.3477L15 17.0977L9.75 22.3477L7.65234 20.25L12.9023 15L7.65234 9.75L9.75 7.65234L15 12.9023L20.25 7.65234L22.3477 9.75L17.0977 15L22.3477 20.25Z",
                            fill: "white"
                        }),
                        id: "mask0",
                        height: "30",
                        width: "30",
                        maskUnits: "userSpaceOnUse",
                        x: "0",
                        y: "0"
                    }),
                    react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx("g", {
                        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx("path", {
                            d: "M15 0C6.75 0 0 6.75 0 15C0 23.25 6.75 30 15 30C23.25 30 30 23.25 30 15C30 6.75 23.25 0 15 0ZM22.3477 20.25L20.25 22.3477L15 17.0977L9.75 22.3477L7.65234 20.25L12.9023 15L7.65234 9.75L9.75 7.65234L15 12.9023L20.25 7.65234L22.3477 9.75L17.0977 15L22.3477 20.25Z",
                            fill: "#C20D16"
                        }),
                        mask: "url(#mask0)"
                    })
                ],
                className: notificationStyle,
                height: "30",
                width: "30",
                viewBox: "0 0 30 30",
                xmlns: "http://www.w3.org/2000/svg"
            });
        case /* NotificationInfo */ 1:
            return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx("svg", {
                children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx("path", {
                    clipRule: "evenodd",
                    d: "M15 30C18.9781 30 22.7931 28.4192 25.6066 25.6066C28.4191 22.7928 30 18.9781 30 15C30 11.0219 28.4192 7.20687 25.6066 4.39344C22.7928 1.58094 18.9781 0 15 0C11.0219 0 7.20687 1.58081 4.39344 4.39344C1.58094 7.20716 0 11.0219 0 15C0 18.9781 1.58081 22.7931 4.39344 25.6066C7.20716 28.4191 11.0219 30 15 30ZM15 6.5625C15.7581 6.5625 16.4417 7.01903 16.7322 7.71972C17.0227 8.42041 16.8616 9.22728 16.3257 9.76319C15.7898 10.2991 14.9829 10.4602 14.2822 10.1697C13.5815 9.87916 13.125 9.19556 13.125 8.4375C13.125 7.40234 13.9648 6.5625 15 6.5625ZM13.125 13.125L16.875 13.125V23.4375H13.125L13.125 13.125Z",
                    fill: "#2E5299",
                    fillRule: "evenodd"
                }),
                className: notificationStyle,
                height: "30",
                width: "30",
                viewBox: "0 0 30 30",
                xmlns: "http://www.w3.org/2000/svg"
            });
        case /* NotificationSuccess */ 2:
            return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx("svg", {
                children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx("path", {
                    clipRule: "evenodd",
                    d: "M15 0C23.2843 0 30 6.71573 30 15C30 23.2843 23.2843 30 15 30C6.71573 30 0 23.2843 0 15C0 6.71573 6.71573 0 15 0ZM20.7973 9L12.8003 16.9949L9.10428 13.6131L7 15.9122L12.8957 21.3069L23 11.2027L20.7973 9Z",
                    fill: "#25AE88",
                    fillRule: "evenodd"
                }),
                className: notificationStyle,
                height: "30",
                width: "30",
                viewBox: "0 0 30 30",
                xmlns: "http://www.w3.org/2000/svg"
            });
        case /* NotificationWarning */ 3:
            return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx("svg", {
                children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx("path", {
                    clipRule: "evenodd",
                    d: "M15 0C11.0219 0 7.20688 1.58081 4.39344 4.39344C1.58094 7.20716 0 11.0219 0 15C0 18.9781 1.58081 22.7931 4.39344 25.6066C7.20716 28.4191 11.0219 30 15 30C18.9781 30 22.7931 28.4192 25.6066 25.6066C28.4191 22.7928 30 18.9781 30 15C30 11.0219 28.4192 7.20687 25.6066 4.39344C22.7928 1.58094 18.9781 0 15 0ZM15 23.4375C14.2419 23.4375 13.5583 22.981 13.2678 22.2803C12.9773 21.5796 13.1384 20.7727 13.6743 20.2368C14.2102 19.7009 15.0171 19.5398 15.7178 19.8303C16.4185 20.1208 16.875 20.8044 16.875 21.5625C16.875 22.5977 16.0352 23.4375 15 23.4375ZM16.875 16.875H13.125V6.5625H16.875V16.875Z",
                    fill: "#DC5800",
                    fillRule: "evenodd"
                }),
                className: rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .make */ .S([
                    notificationStyle,
                    "text-teal-500"
                ]),
                height: "30",
                width: "30",
                viewBox: "0 0 30 30",
                xmlns: "http://www.w3.org/2000/svg"
            });
    }
}
var innerContainer = "flex";
var titleStyle = "font-bold text-lg text-dark-gray pb-1";
var descriptionStyle = "text-base text-dark-gray";
 /* react/jsx-runtime Not a pure module */ 


/***/ }),

/***/ 38099:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony export Link */
/* harmony import */ var rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20859);
/* harmony import */ var _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7667);
/* harmony import */ var _Button_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59037);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);
// Generated by ReScript, PLEASE EDIT WITH CARE





function OnboardingLayoutCreateAccountButton(props) {
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs("div", {
        children: [
            react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx("p", {
                children: _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s("Not registered?"),
                className: "text-light-gray text-sm mr-6"
            }),
            react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                href: "/register",
                prefetch: false,
                children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx("button", {
                    children: _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s("Create an account"),
                    "aria-label": "Register",
                    className: rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_4__/* .make */ .S([
                        "w-40 h-12 ml-1",
                        _Button_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .primaryOutlineStyle */ .e1
                    ]),
                    type: "button"
                })
            })
        ],
        className: "flex items-center float-right mr-4 lg:mr-10"
    });
}
var Link$1;
var make = OnboardingLayoutCreateAccountButton;
 /* Util Not a pure module */ 


/***/ }),

/***/ 81036:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony export Head */
/* harmony import */ var _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7667);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2962);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(72491);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);
// Generated by ReScript, PLEASE EDIT WITH CARE






function SeoMeta(props) {
    var meta = props.meta;
    var router = next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter();
    var match = meta.seoMetaOgType.length;
    var ogType = match !== 0 ? meta.seoMetaOgType : "website";
    var ogImageAssetUrl = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_5__/* .mapWithDefault */ .k7(meta.seoMetaOgImageAsset, "", function(b) {
        return b.url;
    });
    var twImageAssetUrl = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_5__/* .map */ .UI(meta.seoMetaTwImageAsset, function(b) {
        return b.url;
    });
    var twImageUrl = twImageAssetUrl !== undefined ? twImageAssetUrl : meta.seoMetaTwImageAssetUrl;
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
        children: [
            react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
                title: meta.seoMetaBasicTitle,
                description: meta.seoMetaBasicDescription,
                canonical: _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .SEOUtil.getCanonicalUrl */ .br.getCanonicalUrl(router.asPath),
                languageAlternates: _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .SEOUtil.getLanguageAlternates */ .br.getLanguageAlternates(router.asPath),
                openGraph: {
                    title: meta.seoMetaOgTitle,
                    description: meta.seoMetaOgDescription,
                    url: meta.seoMetaOgUrl
                }
            }),
            react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: [
                    react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx("meta", {
                        content: ogImageAssetUrl,
                        property: "og:image"
                    }),
                    react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx("meta", {
                        content: ogType,
                        property: "og:type"
                    }),
                    react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx("meta", {
                        content: meta.seoMetaTwTitle,
                        property: "twitter:title"
                    }),
                    react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx("meta", {
                        content: meta.seoMetaTwDescription,
                        property: "twitter:description"
                    }),
                    react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx("meta", {
                        content: "summary_large_image",
                        property: "twitter:card"
                    }),
                    react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx("meta", {
                        content: router.pathname,
                        property: "twitter:url"
                    }),
                    react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx("meta", {
                        content: twImageUrl,
                        property: "twitter:image"
                    })
                ]
            })
        ]
    });
}
var Head$1;
var make = SeoMeta;
 /* Util Not a pure module */ 


/***/ }),

/***/ 71764:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "KontentContextConsumer": function() { return /* binding */ KontentContextConsumer; },
/* harmony export */   "Link": function() { return /* binding */ Link$1; },
/* harmony export */   "getCards": function() { return /* binding */ getCards; },
/* harmony export */   "make": function() { return /* binding */ make; }
/* harmony export */ });
/* harmony import */ var _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7667);
/* harmony import */ var _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(92592);
/* harmony import */ var _utils_Regex_bs_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(7618);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _rescript_std_lib_es6_js_dict_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(43437);
/* harmony import */ var _library_SmartLink_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35705);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _rescript_std_lib_es6_js_promise_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(27097);
/* harmony import */ var _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(72491);
/* harmony import */ var _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(25400);
/* harmony import */ var _utils_FormHelpers_bs_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43243);
/* harmony import */ var _utils_FormReducer_bs_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(40367);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _library_Notification_bs_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(88767);
/* harmony import */ var _auth_user_AuthContextTS_bs_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(70026);
/* harmony import */ var _bindings_ReactHookForm_bs_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(77103);
/* harmony import */ var _utils_LayoutDataContext_bs_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(37110);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(85893);
/* harmony import */ var _prezzee_ribbon_src_components_personal_Button_Button_bs_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(10573);
/* harmony import */ var _prezzee_ribbon_src_components_personal_Kontent_Kontent_bs_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(72721);
/* harmony import */ var _LoginOnboardingStyles_bs_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(70983);
/* harmony import */ var _index_KontentContextProvider_bs_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(26396);
/* harmony import */ var _prezzee_ribbon_src_components_personal_TextField_TextField_bs_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(98923);
// Generated by ReScript, PLEASE EDIT WITH CARE























function getCards(wallet) {
    return _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_17__/* .mapWithDefault */ .k7(wallet === null ? undefined : _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_18__/* .some */ .G(wallet), [], function(w) {
        return w.cards;
    });
}
function LoginComponent(props) {
    var purchaseCallback = props.purchaseCallback;
    var isPurchase = props.isPurchase;
    var isPurchase$1 = isPurchase !== undefined ? isPurchase : false;
    var layoutData = _utils_LayoutDataContext_bs_js__WEBPACK_IMPORTED_MODULE_10__/* .useContext */ .qp(undefined);
    var loginData = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_17__/* .flatMap */ .VS(layoutData, function(o) {
        return o.login;
    });
    var match = _utils_FormReducer_bs_js__WEBPACK_IMPORTED_MODULE_5__/* .useFormReducer */ .BZ(undefined);
    var dispatch = match[1];
    var state = match[0];
    var router = next_router__WEBPACK_IMPORTED_MODULE_6__.useRouter();
    var passwordReset = _rescript_std_lib_es6_js_dict_js__WEBPACK_IMPORTED_MODULE_19__/* .get */ .U2(router.query, "passwordReset");
    var giftClaimed = _rescript_std_lib_es6_js_dict_js__WEBPACK_IMPORTED_MODULE_19__/* .get */ .U2(router.query, "giftClaimed");
    var login_title = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_17__/* .mapWithDefault */ .k7(loginData, "Log in to Prezzee", function(c) {
        return c.title;
    });
    var login_subtitle = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_17__/* .flatMap */ .VS(loginData, function(c) {
        return c.subtitle;
    });
    var login_emailLabel = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_17__/* .mapWithDefault */ .k7(loginData, "Email", function(c) {
        return c.emailLabel;
    });
    var login_passwordLabel = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_17__/* .mapWithDefault */ .k7(loginData, "Password", function(c) {
        return c.passwordLabel;
    });
    var login_requiredEmailText = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_17__/* .mapWithDefault */ .k7(loginData, "Your email is required", function(c) {
        return c.requiredEmailText;
    });
    var login_requiredPasswordText = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_17__/* .mapWithDefault */ .k7(loginData, "Your password is required", function(c) {
        return c.requiredPasswordText;
    });
    var login_invalidEmailText = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_17__/* .mapWithDefault */ .k7(loginData, "Please enter a valid email address", function(c) {
        return c.invalidEmailText;
    });
    var login_submitCtaText = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_17__/* .mapWithDefault */ .k7(loginData, "Log in", function(c) {
        return c.submitCtaText;
    });
    var login_submitCtaSubmittingText = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_17__/* .mapWithDefault */ .k7(loginData, "Submitting...", function(c) {
        return c.submitCtaSubmittingText;
    });
    var login_forgotPasswordText = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_17__/* .mapWithDefault */ .k7(loginData, "Forgot your password?", function(c) {
        return c.forgotPasswordText;
    });
    var login_forgotEmailText = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_17__/* .mapWithDefault */ .k7(loginData, "Forgot your email?", function(c) {
        return c.forgotEmailText;
    });
    var login_smartLink = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_17__/* .mapWithDefault */ .k7(loginData, _library_SmartLink_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .emptySmartLink */ .R, function(c) {
        return c.smartLink;
    });
    var emailInput = {
        required: {
            value: true,
            message: login_requiredEmailText
        },
        pattern: {
            value: _utils_Regex_bs_js__WEBPACK_IMPORTED_MODULE_20__/* .emailRegex */ .HN,
            message: login_invalidEmailText
        }
    };
    var passwordInput = {
        required: {
            value: true,
            message: login_requiredPasswordText
        }
    };
    var form = _bindings_ReactHookForm_bs_js__WEBPACK_IMPORTED_MODULE_9__/* .useForm */ .cI({
        mode: "onChange"
    }, undefined);
    var match$1 = form.formState;
    var authCtx = _auth_user_AuthContextTS_bs_js__WEBPACK_IMPORTED_MODULE_8__/* .useAuth */ .a(undefined);
    var handleLogin = function handleLogin(customerOpt) {
        if (customerOpt === undefined) {
            return;
        }
        var redirectUrl = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_17__/* .getWithDefault */ .tj(_rescript_std_lib_es6_js_dict_js__WEBPACK_IMPORTED_MODULE_19__/* .get */ .U2(router.query, "redirecturl"), "");
        if (redirectUrl !== "") {
            router.push(redirectUrl);
        } else if (isPurchase$1) {
            _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_17__/* .map */ .UI(purchaseCallback, function(cb) {
                _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_21__._1(cb, undefined);
            });
        } else {
            router.push("/wallet");
        }
    };
    var onSubmit = react__WEBPACK_IMPORTED_MODULE_1__.useCallback(function(data) {
        _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_21__._1(dispatch, /* Submit */ 0);
        return _rescript_std_lib_es6_js_promise_js__WEBPACK_IMPORTED_MODULE_22__/* .$$catch */ .y(function(e) {
            _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_21__._1(dispatch, /* Error */ {
                _0: /* UnexpectedError */ 0
            });
            return Promise.resolve(e);
        }, _rescript_std_lib_es6_js_promise_js__WEBPACK_IMPORTED_MODULE_22__/* .then_ */ .k(function(param) {
            return Promise.resolve(undefined);
        }, _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_21__._3(authCtx.login, data.loginEmail, data.loginPassword, handleLogin)));
    }, [
        isPurchase$1
    ]);
    var x = login_subtitle;
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx(_index_KontentContextProvider_bs_js__WEBPACK_IMPORTED_MODULE_15__/* .make */ .S, {
            children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx(_prezzee_ribbon_src_components_personal_Kontent_Kontent_bs_js__WEBPACK_IMPORTED_MODULE_13__/* .Consumer.make */ .$.make, {
                children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs("div", {
                    children: [
                        authCtx.error !== null ? react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx(_library_Notification_bs_js__WEBPACK_IMPORTED_MODULE_7__.make, {
                            notificationType: /* NotificationInfo */ 1,
                            title: "Login error",
                            description: authCtx.error !== null ? authCtx.error.message : "",
                            className: _LoginOnboardingStyles_bs_js__WEBPACK_IMPORTED_MODULE_14__/* .accountMsg */ .Ir
                        }, "loginNotification") : null,
                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx("h1", {
                            children: _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s(_rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_17__/* .mapWithDefault */ .k7(passwordReset, login_title, function(param) {
                                return "Success!";
                            })),
                            className: _LoginOnboardingStyles_bs_js__WEBPACK_IMPORTED_MODULE_14__/* .title */ .TN
                        }),
                        x !== undefined ? react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx("h2", {
                            children: _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s(_rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_17__/* .mapWithDefault */ .k7(passwordReset, x, function(param) {
                                return "Sign in with your new details";
                            })),
                            className: _LoginOnboardingStyles_bs_js__WEBPACK_IMPORTED_MODULE_14__/* .subtitle */ .Oc
                        }) : null,
                        _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_17__/* .mapWithDefault */ .k7(giftClaimed, null, function(query) {
                            if (query === "true") {
                                return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx(_library_Notification_bs_js__WEBPACK_IMPORTED_MODULE_7__.make, {
                                    notificationType: /* NotificationInfo */ 1,
                                    description: "This eGift card has been added to a Prezzee wallet",
                                    className: _LoginOnboardingStyles_bs_js__WEBPACK_IMPORTED_MODULE_14__/* .accountMsg */ .Ir
                                }, "loginNotification");
                            } else {
                                return null;
                            }
                        }),
                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs("form", {
                            children: [
                                react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx(_prezzee_ribbon_src_components_personal_TextField_TextField_bs_js__WEBPACK_IMPORTED_MODULE_16__/* .make */ .Sy, {
                                    autoComplete: "email",
                                    className: _LoginOnboardingStyles_bs_js__WEBPACK_IMPORTED_MODULE_14__/* .formInput_ */ .Gr,
                                    disabled: state.isSubmitting,
                                    label: login_emailLabel,
                                    name: "loginEmail",
                                    type_: "text",
                                    error: _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_17__/* .isSome */ .pC(_utils_FormHelpers_bs_js__WEBPACK_IMPORTED_MODULE_4__/* .getTouchedError */ .xw(form, "loginEmail")),
                                    helperText: _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_17__/* .getWithDefault */ .tj(_utils_FormHelpers_bs_js__WEBPACK_IMPORTED_MODULE_4__/* .getTouchedError */ .xw(form, "loginEmail"), ""),
                                    inputRef: _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_18__/* .some */ .G(_rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_21__._1(form.register, emailInput))
                                }),
                                react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx(_prezzee_ribbon_src_components_personal_TextField_TextField_bs_js__WEBPACK_IMPORTED_MODULE_16__/* .make */ .Sy, {
                                    className: _LoginOnboardingStyles_bs_js__WEBPACK_IMPORTED_MODULE_14__/* .formInput_ */ .Gr,
                                    disabled: state.isSubmitting,
                                    label: login_passwordLabel,
                                    name: "loginPassword",
                                    type_: "password",
                                    error: _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_17__/* .isSome */ .pC(_utils_FormHelpers_bs_js__WEBPACK_IMPORTED_MODULE_4__/* .getFieldError */ .zQ(form.errors, "loginPassword")),
                                    helperText: _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_17__/* .getWithDefault */ .tj(_utils_FormHelpers_bs_js__WEBPACK_IMPORTED_MODULE_4__/* .getTouchedError */ .xw(form, "loginPassword"), ""),
                                    inputRef: _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_18__/* .some */ .G(_rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_21__._1(form.register, passwordInput))
                                }),
                                react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx(_prezzee_ribbon_src_components_personal_Button_Button_bs_js__WEBPACK_IMPORTED_MODULE_12__.make, {
                                    children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx("button", {
                                        children: _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s(state.isSubmitting ? login_submitCtaSubmittingText : login_submitCtaText),
                                        className: _LoginOnboardingStyles_bs_js__WEBPACK_IMPORTED_MODULE_14__/* .loginBtn */ .PV,
                                        disabled: !match$1.isDirty || !match$1.isValid || state.isSubmitting
                                    })
                                })
                            ],
                            onSubmit: _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_21__._2(form.handleSubmit, onSubmit, _utils_FormHelpers_bs_js__WEBPACK_IMPORTED_MODULE_4__/* .onError */ .qQ)
                        }),
                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs("div", {
                            children: [
                                react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                    href: "/forgot-password",
                                    prefetch: false,
                                    children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx("a", {
                                        children: _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s(login_forgotPasswordText),
                                        className: _LoginOnboardingStyles_bs_js__WEBPACK_IMPORTED_MODULE_14__/* .linkStyle */ .RP
                                    })
                                }),
                                react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                    href: "/forgot-email-address",
                                    prefetch: false,
                                    children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx("a", {
                                        children: _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s(login_forgotEmailText),
                                        className: _LoginOnboardingStyles_bs_js__WEBPACK_IMPORTED_MODULE_14__/* .linkStyle */ .RP
                                    })
                                })
                            ],
                            className: _LoginOnboardingStyles_bs_js__WEBPACK_IMPORTED_MODULE_14__/* .forgotBlock */ .uZ
                        })
                    ]
                })
            }),
            itemId: login_smartLink.itemId,
            elementCodename: login_smartLink.codename
        })
    });
}
var Link$1;
var KontentContextConsumer;
var make = LoginComponent;
 /* Util Not a pure module */ 


/***/ }),

/***/ 70983:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gr": function() { return /* binding */ formInput_; },
/* harmony export */   "Ir": function() { return /* binding */ accountMsg; },
/* harmony export */   "Oc": function() { return /* binding */ subtitle; },
/* harmony export */   "PV": function() { return /* binding */ loginBtn; },
/* harmony export */   "RP": function() { return /* binding */ linkStyle; },
/* harmony export */   "TN": function() { return /* binding */ title; },
/* harmony export */   "_W": function() { return /* binding */ loginContainer; },
/* harmony export */   "uZ": function() { return /* binding */ forgotBlock; }
/* harmony export */ });
/* unused harmony exports textStyle, errorTextStyle */
/* harmony import */ var _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71863);
/* harmony import */ var _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92592);
/* harmony import */ var _css_Theme_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93802);
/* harmony import */ var _prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70965);
// Generated by ReScript, PLEASE EDIT WITH CARE




var title = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_3__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontSize */ .JBY(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .rem */ .hOB(1.875)),
    tl: {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontWeight */ .Ue2("bold"),
        tl: {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .color */ .$_Y(_css_Theme_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .Color.gray800 */ .Il.gray800),
            tl: {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontSize */ .JBY(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(24)),
                tl: {
                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .textAlign */ .ydu("center"),
                    tl: {
                        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .media */ .BC2(_prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .desktop */ .gv, {
                            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .textAlign */ .ydu("left"),
                            tl: /* [] */ 0
                        }),
                        tl: {
                            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .media */ .BC2(_prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .tabletSmUp */ .Uv, {
                                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontSize */ .JBY(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .rem */ .hOB(2.5)),
                                tl: /* [] */ 0
                            }),
                            tl: /* [] */ 0
                        }
                    }
                }
            }
        }
    }
});
var formInput_ = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_3__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .width */ .bf$(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .pct */ .hdZ(100)),
    tl: {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .textAlign */ .ydu("left"),
        tl: {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .margin2 */ .h9x(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(6), _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .zero */ .bMI),
            tl: /* [] */ 0
        }
    }
});
var errorTextStyle = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_3__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .display */ .jfB("block"),
    tl: {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .textAlign */ .ydu("left"),
        tl: {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontSize */ .JBY(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .rem */ .hOB(0.75)),
            tl: {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .marginBottom */ .yl7(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .rem */ .hOB(0.5)),
                tl: {
                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .marginLeft */ .oIA(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(-2)),
                    tl: {
                        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .color */ .$_Y(_css_Theme_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .Color.prezzeeRed */ .Il.prezzeeRed),
                        tl: /* [] */ 0
                    }
                }
            }
        }
    }
});
var forgotBlock = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_3__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .display */ .jfB("flex"),
    tl: {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .flexDirection */ .Me8("column"),
        tl: {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .justifyContent */ .KlP("center"),
            tl: {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .alignItems */ .cq$("center"),
                tl: /* [] */ 0
            }
        }
    }
});
var linkStyle = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_3__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .display */ .jfB("block"),
    tl: {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .textDecoration */ .QXS("underline"),
        tl: {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .color */ .$_Y(_css_Theme_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .Color.blue400 */ .Il.blue400),
            tl: {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .focus */ .T_4({
                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .color */ .$_Y(_css_Theme_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .Color.blue600 */ .Il.blue600),
                    tl: /* [] */ 0
                }),
                tl: {
                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hover */ .MrM({
                        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .color */ .$_Y(_css_Theme_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .Color.blue600 */ .Il.blue600),
                        tl: /* [] */ 0
                    }),
                    tl: {
                        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .paddingTop */ .odA(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(15)),
                        tl: /* [] */ 0
                    }
                }
            }
        }
    }
});
var subtitle = "sm:text-xl text-mid-gray text-center lg:text-left pb-8";
var accountMsg = "w-full mb-4";
var loginContainer = "w-full max-w-md mt-24 mx-auto px-4";
var textStyle = "block text-gray-800 text-sm font-bold mb-2 text-left mt-5";
var loginBtn = "mx-auto w-32 h-12 mt-6";
 /* title Not a pure module */ 


/***/ }),

/***/ 8103:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony export features */
/* harmony import */ var _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7667);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96533);
/* harmony import */ var _components_StaticImage_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30369);
/* harmony import */ var _components_library_DownloadAppleApp_bs_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75897);
/* harmony import */ var _components_library_DownloadGoogleApp_bs_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59195);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);
// Generated by ReScript, PLEASE EDIT WITH CARE







var features = [
    "Keep all my eGift cards in one place",
    "Fast access from my phone while I shop",
    "Secure digital wallet",
    "Get offers",
    "Send gift cards even faster"
];
var make = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.memo(function(props) {
    var onboardingKind = props.onboardingKind;
    var match = _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .EnvUtil.currentCountry */ .i3.currentCountry;
    var deviseImg;
    deviseImg = match.TAG === /* Ok */ 0 && match._0 === 3 ? {
        width: 448,
        height: 265,
        src: "/images/laptop_wallet.png",
        alt: "Prezzee wallet"
    } : {
        width: 448,
        height: 275,
        src: "/images/prezzee_desktop_wallet.png",
        alt: "Prezzee wallet"
    };
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs("div", {
        children: [
            react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx("div", {
                children: typeof onboardingKind === "number" ? onboardingKind !== 0 ? react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs("div", {
                    children: [
                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs("div", {
                            children: [
                                react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs("h2", {
                                    children: [
                                        _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s("Never forget a"),
                                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx("br", {}),
                                        _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s("gift card again.")
                                    ],
                                    className: "font-semibold text-3xl text-white mb-4 "
                                }),
                                react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs("p", {
                                    children: [
                                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx("strong", {
                                            children: _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s("Buy, send and store ")
                                        }),
                                        _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s("gift cards, all"),
                                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx("br", {}),
                                        _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s("with a few clicks in the Prezzee App."),
                                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx("br", {}),
                                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx("strong", {
                                            children: _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s("Download for free now.")
                                        })
                                    ],
                                    className: "text-lg text-white font-thin leading-relaxed mb-8"
                                }),
                                react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs("div", {
                                    children: [
                                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx(_components_library_DownloadGoogleApp_bs_js__WEBPACK_IMPORTED_MODULE_4__/* .make */ .S, {
                                            className: "mr-3 w-32"
                                        }),
                                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx(_components_library_DownloadAppleApp_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .make */ .S, {
                                            className: "ml-3 w-32"
                                        })
                                    ],
                                    className: "flex"
                                })
                            ],
                            className: ""
                        }),
                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx("div", {
                            children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx(_components_StaticImage_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .make */ .S, {
                                src: "/images/prezzee_mobile_app.png",
                                alt: "Prezzee iOS and Android mobile applications",
                                width: 448,
                                height: 457,
                                className: "max-w-md w-full h-auto py-6 my-auto"
                            }),
                            className: "flex-grow flex"
                        })
                    ],
                    className: "px-2 xl:px-10 xxl:px-16 flex flex-col flex-grow"
                }) : react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs("div", {
                    children: [
                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx("ul", {
                            children: _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.ate */ .p_.ate(_rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_6__/* .mapWithIndex */ .Su(features, function(index, feature) {
                                return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs("li", {
                                    children: [
                                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx("div", {
                                            children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx(_components_StaticImage_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .make */ .S, {
                                                src: "/images/icon_tick.svg",
                                                alt: feature,
                                                width: 20,
                                                height: 20
                                            }),
                                            className: "mt-1 mr-4"
                                        }),
                                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx("span", {
                                            children: _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s(feature),
                                            className: "block w-full max-w-xs"
                                        })
                                    ],
                                    className: "flex mb-8"
                                }, "index-" + String(index));
                            })),
                            className: "flex-grow text-white text-xl"
                        }),
                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx(_components_StaticImage_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .make */ .S, {
                            src: deviseImg.src,
                            alt: deviseImg.alt,
                            width: deviseImg.width,
                            height: deviseImg.height,
                            className: "max-w-md w-full h-auto py-6 mt-auto"
                        })
                    ],
                    className: "px-2 xl:px-10 xxl:px-16 flex flex-col flex-grow"
                }) : react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs("div", {
                    children: [
                        _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_6__/* .mapWithIndex */ .Su(onboardingKind._0, function(i, text) {
                            return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx("h2", {
                                children: _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s(text),
                                className: "font-bold text-4xl text-white text-center"
                            }, "title" + String(i));
                        }),
                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx(_components_StaticImage_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .make */ .S, {
                            src: "/images/presents.svg",
                            alt: "Presents",
                            width: 518,
                            height: 303,
                            className: "w-full pt-20 flex-grow"
                        })
                    ]
                }),
                className: "hidden w-full lg:flex flex-col lg:w-1/3 py-20 pb-5 px-5 bg-prezzee-red"
            }),
            react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx("div", {
                children: props.children,
                className: "w-full lg:w-2/3 bg-white text-center py-5"
            })
        ],
        className: "flex flex-wrap-reverse w-full"
    });
});
 /* make Not a pure module */ 


/***/ }),

/***/ 40367:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BZ": function() { return /* binding */ useFormReducer; }
/* harmony export */ });
/* unused harmony exports initialState, reducer */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25400);
// Generated by ReScript, PLEASE EDIT WITH CARE


var initialState = {
    isSubmitting: false,
    error: undefined
};
function reducer(param, action) {
    if (typeof action === "number") {
        if (action !== 0) {
            return initialState;
        } else {
            return {
                isSubmitting: true,
                error: undefined
            };
        }
    } else {
        return {
            isSubmitting: false,
            error: _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_1__/* .some */ .G(action._0)
        };
    }
}
function useFormReducer(param) {
    return react__WEBPACK_IMPORTED_MODULE_0__.useReducer(reducer, initialState);
}
 /* react Not a pure module */ 


/***/ }),

/***/ 73763:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Qc": function() { return /* binding */ parse; },
/* harmony export */   "UW": function() { return /* binding */ resolver; }
/* harmony export */ });
/* unused harmony export modifyBlocks */
/* harmony import */ var _glennsl_bs_json_src_Json_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57687);
/* harmony import */ var _common_util_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7667);
/* harmony import */ var _api_graphql_CmsData_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(607);
/* harmony import */ var _rescript_std_lib_es6_js_dict_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(43437);
/* harmony import */ var _rescript_std_lib_es6_js_null_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(94518);
/* harmony import */ var _common_Constants_bs_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47800);
/* harmony import */ var _rescript_std_lib_es6_js_string_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(37712);
/* harmony import */ var _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96533);
/* harmony import */ var _rescript_std_lib_es6_js_promise_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(27097);
/* harmony import */ var _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72491);
/* harmony import */ var _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(25400);
/* harmony import */ var _api_queries_modifyBlocks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23328);
// Generated by ReScript, PLEASE EDIT WITH CARE












function modifyBlocks(prim0, prim1, prim2) {
    return ModifyBlocks.modifyBlocks(prim0, prim1, prim2);
}
function resolver(ctx, url, param) {
    if (_rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_4__/* .isNone */ .Wi(_rescript_std_lib_es6_js_dict_js__WEBPACK_IMPORTED_MODULE_5__/* .get */ .U2(ctx.query, "preview"))) {
        ctx.res.setHeader("Cache-Control", _common_Constants_bs_js__WEBPACK_IMPORTED_MODULE_6__/* .ssr_page_cache */ .p5);
    }
    var isPreview = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_4__/* .isSome */ .pC(_rescript_std_lib_es6_js_dict_js__WEBPACK_IMPORTED_MODULE_5__/* .get */ .U2(ctx.query, "preview"));
    var i = _rescript_std_lib_es6_js_dict_js__WEBPACK_IMPORTED_MODULE_5__/* .get */ .U2(ctx.query, "lang");
    var language = i !== undefined ? i : null;
    var path = _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_7__/* .get */ .U2(_rescript_std_lib_es6_js_string_js__WEBPACK_IMPORTED_MODULE_8__/* .split */ .Vl("?", ctx.resolvedUrl), 0);
    var queryUrl = url !== undefined ? url : path !== undefined ? path : "";
    return _rescript_std_lib_es6_js_promise_js__WEBPACK_IMPORTED_MODULE_9__/* .then_ */ .k(function(res) {
        var content = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_4__/* .flatMap */ .VS(res, function(p) {
            return p.content;
        });
        var result = _rescript_std_lib_es6_js_null_js__WEBPACK_IMPORTED_MODULE_10__/* .fromOption */ .Yo(JSON.stringify(content));
        return _rescript_std_lib_es6_js_promise_js__WEBPACK_IMPORTED_MODULE_9__/* .then_ */ .k(function(modifiedResult) {
            return Promise.resolve({
                props: {
                    content: modifiedResult
                }
            });
        }, _api_queries_modifyBlocks__WEBPACK_IMPORTED_MODULE_3__/* .modifyBlocks */ .IN(result, isPreview, _common_util_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .EnvUtil.getCmsLanguage */ .i3.getCmsLanguage(language)));
    }, _api_graphql_CmsData_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .getPageContent */ .nW(_common_util_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .EnvUtil.getCmsLanguage */ .i3.getCmsLanguage(language), isPreview, queryUrl));
}
function parse(data) {
    return _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_4__/* .map */ .UI(data == null ? undefined : _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_11__/* .some */ .G(data), _glennsl_bs_json_src_Json_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .parseOrRaise */ .YF);
}
 /* Util Not a pure module */ 


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1758,9774,2888,179], function() { return __webpack_exec__(78883); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);